import dayjs from "dayjs";

const MINUTES_IN_DAY = 1440;
const MINUTES_IN_HOUR = 60;

export function getDurationFromToday(
  date: Date
): { days: number; hours: number; minutes: number } {
  const todaysDate = dayjs(new Date());
  const dayJsDate = dayjs(date);

  let totalMinutes = Math.abs(todaysDate.diff(dayJsDate, "minute"));
  let days = 0;
  let hours = 0;
  let minutes = 0;
  while (totalMinutes > 0) {
    if (totalMinutes >= MINUTES_IN_DAY) {
      days += 1;
      totalMinutes -= MINUTES_IN_DAY;
    } else if (totalMinutes >= MINUTES_IN_HOUR) {
      hours += 1;
      totalMinutes -= MINUTES_IN_HOUR;
    } else {
      minutes = totalMinutes;
      totalMinutes -= totalMinutes;
    }
  }
  return { days, hours, minutes };
}
